"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartDocFieldValueGetter = void 0;
const safe_field_value_1 = require("../../safe-field-value");
const get_value_1 = require("./get-value");
const smart_doc_1 = require("../../type-checking/smart-doc");
class SmartDocFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return ((0, smart_doc_1.isPreviewSmartDocValue)(fieldValue) || (0, smart_doc_1.isFullSmartDocValue)(fieldValue));
        };
        this.getEmptyValue = () => (0, get_value_1.getSmartDocFieldEmptyValue)();
    }
}
exports.SmartDocFieldValueGetter = SmartDocFieldValueGetter;
